import { Button } from 'antd';

/**
 * Multi-select chip group. Chips stay real buttons (aria-pressed) so keyboard users
 * and tests can toggle them; the selected state is rendered by Ant rather than a legacy class.
 */
export function ChoiceChips<T extends string>({ options, selected, onToggle, disabled, title, render }: {
  options: readonly T[];
  selected: readonly T[];
  onToggle: (v: T) => void;
  disabled?: (v: T) => boolean;
  title?: (v: T) => string | undefined;
  render?: (v: T) => React.ReactNode;
}) {
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
      {options.map((o) => {
        const on = selected.includes(o);
        return (
          <Button key={o} size="small" shape="round" type={on ? 'primary' : 'default'} aria-pressed={on} disabled={disabled?.(o)} title={title?.(o)} onClick={() => onToggle(o)}>
            {render ? render(o) : o}
          </Button>
        );
      })}
    </div>
  );
}

/** A single non-toggling chip-style action (e.g. "+ add template"). */
export function ChipButton({ children, onClick, disabled }: { children: React.ReactNode; onClick: () => void; disabled?: boolean }) {
  return <Button size="small" shape="round" disabled={disabled} onClick={onClick}>{children}</Button>;
}
